import table from './pedidos'
// Verificando suporte ao IndexedDB
const suporteIndexedDB = ()=>{
    //Verificando se o browser tem suporte ao IndexedDB
    const indexedDB = window.indexedDB || window.mozIndexedDB ||
      window.webkitIndexedDB || window.msIndexedDB
    return indexedDB
}
// Verificando se o banco existe e dados foram criados
const readPedido = () => {
  const pedidos = []
  const request = indexedDB.open("meusPedidos", 3)
  request.onsuccess = function(event) {
    // Fazer algo com request.result!
    const db = request.result
    const transaction = db.transaction(["pedidos"])
    const objectStore = transaction.objectStore("pedidos")
    // const req = objectStore.get(idForSearch)
    const reqAll = objectStore.getAll()
    reqAll.onsuccess = function(event) {
      const resultPedidos = reqAll.result
      // console.log('resultPedidos ', resultPedidos);
       pedidos.push(resultPedidos)
    }
  }
  return pedidos
}
// Definindo o nome do banco e criando
const createDataBase = () => {

  const request = indexedDB.open("meusPedidos", 3);

  request.onupgradeneeded = function(event) {

    const db = event.target.result
    // Cria um objectStore para conter a informação sobre vendas.
    // Cria um índice para buscar vendas pelo id
    const objectStore = db.createObjectStore("pedidos", { keyPath: 'id', autoIncrement: true } );

    //Criar os índices ou propriedades do objeto
    objectStore.createIndex("name", "name", { unique: false });
    objectStore.createIndex("descricao", "descricao", { unique: false });
    objectStore.createIndex("qtde", "qtde", { unique: false });
    objectStore.createIndex("preco", "preco", { unique: false });
    objectStore.createIndex("subtotal", "subtotal", { unique: false });
    // Cria um objectStore para conter a informação sobre clientes.
    // Cria um índice para buscar cliente pelo id
    const clienteObjectStore = db.createObjectStore("cliente", { keyPath: 'id', autoIncrement: true } );

    //Criar os índices ou propriedades do objeto
    clienteObjectStore.createIndex("name", "name", { unique: false });
    clienteObjectStore.createIndex("rua", "rua", { unique: false });
    clienteObjectStore.createIndex("numero", "numero", { unique: false });
    clienteObjectStore.createIndex("telefone", "telefone", { unique: false });
    // preenchendo a base de dados com os valores
    setTimeout(()=>{
      table.create()
    }, 5000)

  }
}

export default { suporteIndexedDB, createDataBase, readPedido}
